import React from 'react';
import PropTypes from 'prop-types';

import { borderGrey } from 'common/constants/colors';
import { ATTRIBUTE_TYPE_PROPTYPE } from 'common/constants/commonPropTypes';
import PaneHeader from './PaneHeader';
import PaneItem from './PaneItem';

const AttributeTypePane = ({ paneName, paneItems, onSelectItem, selectedItem, onAdd, onEdit }) => (
  <div style={{ borderRight: `solid 1px ${borderGrey}`, width: '25vw' }}>
    <PaneHeader onAdd={onAdd} paneName={paneName} />
    <div style={{ margin: '10px' }}>
      {paneItems
                && paneItems.map(item => (
                  <PaneItem
                    isSelected={selectedItem === item}
                    item={item}
                    key={item.name}
                    onClick={() => onSelectItem(item)}
                    onEdit={onEdit}
                  />
                ))}
    </div>
  </div>
);
AttributeTypePane.propTypes = {
  paneName: PropTypes.string.isRequired,
  paneItems: PropTypes.arrayOf(ATTRIBUTE_TYPE_PROPTYPE),
  onSelectItem: PropTypes.func.isRequired,
  selectedItem: ATTRIBUTE_TYPE_PROPTYPE,
  onAdd: PropTypes.func,
  onEdit: PropTypes.func.isRequired,
};
AttributeTypePane.defaultProps = { paneItems: [], selectedItem: undefined, onAdd: undefined };

export default AttributeTypePane;
